import { PayloadAction } from "@reduxjs/toolkit";
import { ProposalReduxState } from "../types";

const SetProposalLoading = (
  state: ProposalReduxState,
  { payload }: PayloadAction<boolean>,
) => {
  state.isLoading = payload;
};

const LoadingReducers = {
  SetProposalLoading,
};

export default LoadingReducers;
